
import {GET_VEHICLE_LOGS_ERROR} from "../../reducers/vehicleReducer";


export const getVehicleLogsError = (error) =>{
    return {
        type: GET_VEHICLE_LOGS_ERROR,
        payload: {error}
    }
}